export default __webpack_public_path__ + "media/images/users/user-mark-johnson-270x270-a0583d78875eb7965b009a2b07b501f7.jpg";